import { createTheme } from "@mui/material/styles";
import { tokens, tokensDark } from "../tokens";
import { componentOverrides } from "./componentOverrides";

/**
 * Build MUI theme from tokens only. No hardcoded colors.
 * Use getTheme(mode) for dark mode and app-wide ThemeProvider.
 */
function buildThemeOptions(mode = "light") {
  const t = mode === "dark" ? { ...tokens, colors: { ...tokens.colors, ...tokensDark.colors } } : tokens;
  return {
    palette: {
      mode,
      primary: {
        main: t.colors.primary,
        dark: t.colors.primaryDark,
        light: t.colors.primaryLight,
      },
      secondary: {
        main: t.colors.secondary,
      },
      error: {
        main: t.colors.danger,
      },
      success: {
        main: t.colors.success,
      },
      warning: {
        main: t.colors.warning,
      },
      info: {
        main: t.colors.info,
      },
      text: {
        primary: t.colors.text,
        secondary: t.colors.textMuted,
      },
      background: {
        default: t.colors.background,
        paper: t.colors.backgroundAlt,
      },
      divider: t.colors.border,
    },
    shape: {
      borderRadius: t.radius.md,
    },
    spacing: t.spacing.sm,
    typography: {
      fontFamily: t.typography.fontFamily,
      fontWeightMedium: t.typography.fontWeight.medium,
      fontWeightBold: t.typography.fontWeight.bold,
    },
    components: componentOverrides,
  };
}

/**
 * Central MUI theme – single place for createTheme.
 */
export const muiTheme = createTheme(buildThemeOptions("light"));

/**
 * Theme with mode support – use for ThemeProvider and dark mode.
 * Never hardcode light/dark values in overrides; overrides use tokens that switch with mode.
 */
export function getTheme(mode = "light") {
  return createTheme(buildThemeOptions(mode));
}

export default muiTheme;
